module.exports = __webpack_public_path__ + "img/1.7ec2f4c6.jpg";